import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useAppSelector, useAppDispatch } from "store/index";
import { handleUpdateFields } from "store/segments/slice";

import DefaultDropdown from "components/dropdowns/DefaultDropdown/DefaultDropdown";
import SwitchBtn from "components/buttons/SwitchBtn";
import FilterTabs from "components/FilterTabs";
import { selectFilteredGeo } from "store/geoFilter/selectors";
import { getGeoDropdownOptions } from "helpers/geoDropdown";

const SegmentRulesPlatformTab: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [optionsCountries, setOptionsCountries] = useState<
    ReturnType<typeof getGeoDropdownOptions>
  >([]);
  const [optionsOs] = useState<{ value: string; label: string }[]>([
    {
      value: "Mac",
      label: "Mac",
    },
    {
      value: "Windows",
      label: "Windows",
    },
    {
      value: "Linux",
      label: "Linux",
    },
    {
      value: "other",
      label: "other",
    },
  ]);
  const [optionsDevices] = useState<{ value: string; label: string }[]>([
    {
      value: "desktop",
      label: "desktop",
    },
    {
      value: "mobile",
      label: "mobile",
    },
    {
      value: "other",
      label: "other",
    },
  ]);
  const [optionsBrowsers] = useState<{ value: string; label: string }[]>([
    {
      value: "Chrome",
      label: "Chrome",
    },
    {
      value: "Firefox",
      label: "Firefox",
    },
    {
      value: "Edge",
      label: "Edge",
    },
    {
      value: "other",
      label: "other",
    },
  ]);

  const itemPayload = useAppSelector(
    (store) => store.segments.payload?.platformRules
  );
  const payloadFull = useAppSelector((store) => store.segments.payload);
  const geoList = useAppSelector((state) => state.settings.geoList);

  useEffect(() => {
    if (geoList.length) {
      setOptionsCountries(getGeoDropdownOptions(geoList));
    }
  }, [geoList]);

  const handleData = (
    key: string,
    value: string | boolean | number | number[] | string[]
  ) => {
    const existingList = payloadFull?.platformRules || [];
    const updatedRule = {
      ...existingList,
      [key]: value,
    };
    //   @ts-ignore
    dispatch(handleUpdateFields({ platformRules: updatedRule }));
  };

  return (
    <div className="rules-payments-wrapper">
      <div className="segment-rules-form-wrapper">
        <div className="segments-rules-form-box">
          <div className="segments-rules-multiselect">
            <DefaultDropdown
              isBot
              onSelect={(e) => {
                handleData(
                  "countries",
                  itemPayload?.countries
                    ? [...itemPayload?.countries, e as string]
                    : [e as string]
                );
              }}
              placeholder={t("countries")}
              label={t("countries")}
              options={optionsCountries.filter(
                (el) => !itemPayload?.countries?.includes(el.value)
              )}
              disabled={optionsCountries.length <= 0}
            />
            <FilterTabs
              onSelect={(e) => {
                handleData(
                  "countries",
                  // @ts-ignore
                  itemPayload?.countries?.filter((el) => el !== e)
                );
              }}
              options={optionsCountries.filter((el) =>
                itemPayload?.countries?.includes(el.value)
              )}
            />
          </div>
          <div className="segments-rules-multiselect">
            <DefaultDropdown
              isBot
              onSelect={(e) => {
                handleData(
                  "os",
                  itemPayload?.os
                    ? [...itemPayload?.os, e as string]
                    : [e as string]
                );
              }}
              placeholder={t("OS")}
              label={t("OS")}
              options={optionsOs.filter(
                (el) => !itemPayload?.os?.includes(el.value)
              )}
              disabled={optionsOs.length <= 0}
            />
            <FilterTabs
              onSelect={(e) => {
                handleData(
                  "os",
                  // @ts-ignore
                  itemPayload?.os?.filter((el) => el !== e)
                );
              }}
              options={optionsOs.filter((el) =>
                itemPayload?.os?.includes(el.value)
              )}
            />
          </div>
        </div>
        <div className="segments-rules-form-box">
          <div className="segments-rules-multiselect">
            <DefaultDropdown
              isBot
              onSelect={(e) => {
                handleData(
                  "devices",
                  itemPayload?.devices
                    ? [...itemPayload?.devices, e as string]
                    : [e as string]
                );
              }}
              placeholder={t("devices")}
              label={t("devices")}
              options={optionsDevices.filter(
                (el) => !itemPayload?.devices?.includes(el.value)
              )}
              disabled={optionsDevices.length <= 0}
            />
            <FilterTabs
              onSelect={(e) => {
                handleData(
                  "devices",
                  // @ts-ignore
                  itemPayload?.devices?.filter((el) => el !== e)
                );
              }}
              options={optionsDevices.filter((el) =>
                itemPayload?.devices?.includes(el.value)
              )}
            />
          </div>
          <div className="segments-rules-multiselect">
            <DefaultDropdown
              isBot
              onSelect={(e) => {
                handleData(
                  "browsers",
                  itemPayload?.browsers
                    ? [...itemPayload?.browsers, e as string]
                    : [e as string]
                );
              }}
              placeholder={t("browsers")}
              label={t("browsers")}
              options={optionsBrowsers.filter(
                (el) => !itemPayload?.browsers?.includes(el.value)
              )}
              disabled={optionsBrowsers.length <= 0}
            />
            <FilterTabs
              onSelect={(e) => {
                handleData(
                  "browsers",
                  // @ts-ignore
                  itemPayload?.browsers?.filter((el) => el !== e)
                );
              }}
              options={optionsBrowsers.filter((el) =>
                itemPayload?.browsers?.includes(el.value)
              )}
            />
          </div>
          <div className="segments-rules-switcher">
            <SwitchBtn
              activeTxt={t("active")}
              isActive={itemPayload?.isActive === 1}
              handleClick={() =>
                handleData(
                  "isActive",
                  itemPayload?.isActive && itemPayload?.isActive === 1 ? 0 : 1
                )
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SegmentRulesPlatformTab;
